'use strict';

angular.module('amexReconciliationApp')
  .service('UploadingTransactionReceiptsModel', function () {

    var self = this;
    var uploadingTransactions = {};

    self.add = function(transactions) {
      _.forEach(transactions, function(transaction) {
        if(uploadingTransactions[transaction.id]) {
          uploadingTransactions[transaction.id] += 1;
        } else {
          uploadingTransactions[transaction.id] = 1;
        }
      });
    };

    self.remove = function(transactions) {
      _.forEach(transactions, function(transaction) {
        uploadingTransactions[transaction.id] -= 1;
      });
    };
  
    self.hasReceiptsUploading = function(transaction) {
      return uploadingTransactions[transaction.id] > 0;
    };

    self.anyReceiptsUploading = function() {
      return !!_.find(uploadingTransactions, function(numberOfUploadingReceipts) {
        return numberOfUploadingReceipts > 0;
      });
    };
  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/models/UploadingTransactionReceiptsModel.js
// module id = 596
// module chunks = 0